import React, { useCallback } from 'react';
import { Textbox } from '@cvent/carina/components/Forms';
import { useTranslate } from 'nucleus-text';

import { validateFormField } from '@components/helpers/FormHelpers';

type IdentityProviderNameTextboxProps = {
  testID: string;
};

export const IdentityProviderNameTextbox = ({ testID }: IdentityProviderNameTextboxProps): JSX.Element => {
  const { translate } = useTranslate();

  const validate = useCallback(val => validateFormField(val, translate('redirect_enterOrgId__resx')), [translate]);
  return (
    <Textbox
      name="identityProviderName"
      label={translate('redirect_orgId__resx')}
      testID={`${testID}_identityProviderName`}
      validate={validate}
    />
  );
};
